import React, { Suspense } from 'react';
import { useLocale } from '../../contexts/LocaleContext';
import { getDefaultMeasurementUnit } from '../../lib/size';
import * as types from '../../types';
import Loading from '../Loading';
import { SimpleDismissableModal } from '../modals';
import styles from './HardwareFirstSizingModal.module.scss';

const DynamicSizingGuide = React.lazy(
  () => import('../../views/ProductDetails/components/SizingGuide/DynamicSizingGuide'),
);

interface HardwareFirstSizingModalProps {
  onOpen?: () => void;
  onSelect: (size: types.SizeOption) => void;
  trigger: JSX.Element;
}

/**
 * "Which size is right for my dog?" on the hardware-first size step: the sizing guide's breed and
 * weight inputs alone, without its general-suggestions list. The step behind it already lists the
 * five bands, so repeating them here gave the shopper the same choice twice instead of an answer.
 */
export default function HardwareFirstSizingModal({ onOpen, onSelect, trigger }: HardwareFirstSizingModalProps) {
  const { country } = useLocale();

  return (
    <SimpleDismissableModal
      closeIconClassName={styles.closeIcon}
      containerClassName={styles.modal}
      onOpen={onOpen}
      trigger={trigger}
    >
      <Suspense fallback={<Loading />}>
        <DynamicSizingGuide
          bandSeries={types.BandSeries.F3}
          measurementUnit={getDefaultMeasurementUnit(country)}
          onSelect={onSelect}
          showGeneralSuggestions={false}
        />
      </Suspense>
    </SimpleDismissableModal>
  );
}
